import { IconButton } from '@mui/joy';
import { IoChatbubbleEllipses } from 'react-icons/io5';

interface ChannelTalkLauncherProps {
  onClick: () => void;
}

/**
 * 채널톡 상담 창을 여는 커스텀 플로팅 버튼(우측 하단 고정).
 * 채널톡 기본 런처는 숨긴 상태에서 이 버튼이 showMessenger 를 호출한다.
 */
const ChannelTalkLauncher = ({ onClick }: ChannelTalkLauncherProps) => {
  return (
    <IconButton
      onClick={onClick}
      variant="solid"
      aria-label="상담 문의"
      sx={{
        // 모바일 뷰포트에서는 숨긴다.
        display: { xs: 'none', md: 'inline-flex' },
        position: 'fixed',
        right: 24,
        bottom: 24,
        zIndex: 1000,
        width: 56,
        height: 56,
        borderRadius: '50%',
        backgroundColor: '#26A7E3',
        color: '#FFFFFF',
        boxShadow: 'md',
        '&:hover': { backgroundColor: '#1E93C9' },
      }}
    >
      <IoChatbubbleEllipses size={26} />
    </IconButton>
  );
};

export default ChannelTalkLauncher;
